import React from 'react';
import { Empty, Spin } from 'antd';
import { isEmpty } from 'underscore';
import { ChartBox } from '../../../../ResultPanel/component/ChartBox';
import styles from '../../Layout/AnalyticsLayout.module.scss';
import ErrorDisplay from '../../ErrorDisplay';

interface PersistenceChartProps {
  persistenceImage: string;
  persistenceLinks: string[];
  pointName: string;
  isLoading: boolean;
  error: string;
  isOfflineDataset: boolean;
}

export default function PersistenceChart({
  persistenceImage,
  persistenceLinks,
  pointName,
  isLoading,
  error,
  isOfflineDataset,
}: PersistenceChartProps) {
  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          minHeight: '400px',
        }}
      >
        <Spin size='large' />
      </div>
    );
  }

  if (isOfflineDataset) {
    return <ErrorDisplay isOfflineDataset={isOfflineDataset} />;
  }

  return (
    <div id='Analytics-Persistence-Plot' className={styles.chartPointWrapper}>
      <ChartBox
        key='Persistence (Weather windows)'
        title='Persistence (Weather windows)'
        height={isLoading || !isEmpty(error) ? '50px' : 'auto'}
        plot={
          isLoading ? (
            <div className={styles.spinner}>
              <Spin size='large' />
            </div>
          ) : !isEmpty(error) && !error.includes('Cmems error') ? (
            <div>{error}</div>
          ) : persistenceImage ? (
            <img
              style={{
                width: '80%',
                objectFit: 'scale-down',
                maxHeight: '55vh',
                display: 'block',
                margin: '0 auto',
              }}
              src={persistenceImage}
              alt='Persistence'
            />
          ) : (
            <Empty
              description={
                error.includes('Cmems error')
                  ? 'Layer not available'
                  : 'No data available'
              }
            />
          )
        }
        dataset=''
        link={persistenceLinks}
      />
    </div>
  );
}
